import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentMapping: {},
  pristineMapping: {},
  editorErrors: {},
};

export const mappingsSlice = createSlice({
 name: "mappings",
 initialState,
 reducers: {
  setMapping: (state, action) => {
   state.currentMapping = action.payload;
   state.pristineMapping = action.payload;
  },
  editMapping: (state, action) => {
   state.currentMapping = { ...state.currentMapping, ...action.payload };
  },
  setEditorErrors: (state, action) => {
    state.editorErrors = action.payload;
  },
 },
});

export const selectEditorErrors = (state) => state.mappingsReducer.editorErrors;
export const selectMappings = (state) => state.mappingsReducer.mappings;
export const selectCurrentMapping = (state) => state.mappingsReducer.currentMapping;
export const selectPristineMapping = (state) => state.mappingsReducer.pristineMapping;

export const { editMapping, setMapping, setEditorErrors } = mappingsSlice.actions;

export default mappingsSlice.reducer;
